import React, { lazy, useContext } from "react";
import { Routes, Route, Navigate } from "react-router";

import MainLayout from "layout/MainLayout";
import MinimalLayout from "layout/MinimalLayout";
import Loadable from "ui-component/Loadable";

import { AuthContext } from "contexts/AuthContext";
import Login from "views/pages/Login";
import DukeOAuthCallbackHandler from "views/pages/DukeOAuthCallbackHandler";
const SuperAdminDashboard = Loadable(lazy(() => import("views/pages/SuperAdminDashboard")));
const UserDashboard = Loadable(lazy(() => import("views/pages/UserDashboard")));
const Organization = Loadable(lazy(() => import("views/pages/Organization")));
const AccountProfile = Loadable(lazy(() => import("views/pages/AccountProfile")));

const ApplicationRoutes = () => {
  const { isAuthenticated, currentUser } = useContext(AuthContext);

  return (
    <Routes>
      {!isAuthenticated && (
        <Route element={<MinimalLayout />}>
          <Route path="login" element={<Login />} />
          <Route path="callback" element={<DukeOAuthCallbackHandler />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Route>
      )}
      {isAuthenticated && (
        <Route path="/" element={<MainLayout />}>
          {currentUser.role === "Admin" ? (
            <React.Fragment>
              <Route index element={<SuperAdminDashboard />} />
              <Route path="organizations" element={<SuperAdminDashboard />} />
              <Route path="organizations/:orgId" element={<Organization />} />
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Route index element={<UserDashboard />} />
            </React.Fragment>
          )}
          <Route path="account-profile" element={<AccountProfile />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      )}
    </Routes>
  );
};

export default ApplicationRoutes;
